export const humanizeEnum = (val: string, capitilize = true) => {
  if (!val) {
    return '';
  }
  let r = val.replace(/[_-]/g, ' '); // change dashes & underscores to spaces
  r = r.replace(/(\/)/g, ' / '); // add spaces around slashes
  r = r.replace(/([A-Z][a-z])/g, ($1) => ` ${$1}`); // prepend spaces before Words
  r = r.replace(/([A-Z]+)/g, ($1) => ` ${$1}`).toLowerCase(); // prepend space before STUFF
  r = r.trim();
  if (capitilize) {
    r = r.replace(/^(.)|\s(.)/g, ($1) => $1.toUpperCase()); // capitilize first letters
  }
  r = r.replace(/\s+/g, ' '); // remove double whitespaces
  return r;
};

export const enumizeString = (val: string) => {
  if (!val) {
    return '';
  }
  let r = val.toLowerCase();
  r = r.replace(/ /g, '_');
  r = r.replace(/(\/)/g, '_');
  return r;
};

export const humanizeBool = (val: boolean) => (val ? 'Yes' : 'No');
